import { useEffect, useState } from 'react';
import { Wizard } from './pages/Wizard';
import { Mesa } from './mesa/Mesa';

export function App() {
  const [hash, setHash] = useState(() => window.location.hash);
  useEffect(() => {
    const onHash = () => setHash(window.location.hash);
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);
  if (hash === '#mesa') return <Mesa />;
  return <Wizard />;
}
